import React, { useState } from 'react'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import {
    Card, CardContent, CardActions, Typography, Divider,
    FormControl, InputAdornment, TextField,
    IconButton, Button, Box,
} from '@mui/material'
import { Auth } from 'aws-amplify';

const ChangePassword = ({ setSnackbarInfo, signOut }) => {
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = React.useState(false);
    const [enableSubmit, setEnableSubmit] = useState(false);
    const [password, setPassword] = useState({
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
    });
    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handlePasswordChange = (type, value) => {
        switch (type) {
            case 'oldPassword':
                setPassword({ ...password, oldPassword: value })
                break;
            case 'newPassword':
                setPassword({ ...password, newPassword: value })
                break;
            case 'confirmPassword':
                setPassword({ ...password, confirmPassword: value })
                break;
            default:
                break;
        }

        if (password.oldPassword !== '' && password.newPassword !== '' && password.confirmPassword !== '') setEnableSubmit(true);
        else setEnableSubmit(false);
    }

    const handleSubmit = () => {
        if (password.oldPassword !== '' && password.newPassword !== '' && password.confirmPassword !== '') {
            if (password.newPassword == password.oldPassword) {
                return setSnackbarInfo({
                    open: true,
                    message: "New password cannot be same as old password",
                    severity: "error",
                });
            }
            if (password.newPassword !== password.confirmPassword) {
                return setSnackbarInfo({
                    open: true,
                    message: "New password and confirm password need to match",
                    severity: "error",
                });
            }

            Auth.currentAuthenticatedUser()
                .then((user) => {
                    handleResetFields();
                    setLoading(false);
                    setSnackbarInfo({
                        open: true,
                        message: "Password changed successfully! Logging out...",
                        severity: "success",
                    });

                    Auth.changePassword(user, password.oldPassword, password.newPassword);
                    return setTimeout(() => {
                        signOut()
                    }, 3000);
                })
                .catch((err) => {
                    console.log(err)
                    setLoading(false);
                    if (err.message === 'Incorrect username or password.' || err.message === 'Attempt limit exceeded, please try after some time.') {
                        return setSnackbarInfo({
                            open: true,
                            message: err.message,
                            severity: "error",
                        });
                    }
                    else return setSnackbarInfo({
                        open: true,
                        message: 'Please check password policy',
                        severity: "error",
                    });
                });
        }
        return setSnackbarInfo({
            open: true,
            message: 'Please check password fields',
            severity: "error",
        });
    }

    const handleResetFields = () => {
        setPassword({
            oldPassword: '',
            newPassword: '',
            confirmPassword: ''
        });
    }

    return (
        <Card variant='outlined' sx={{
            width: '100%'
        }}>
            <Typography variant='h6' sx={{
                padding: 2
            }}>Change Password</Typography>
            <Divider></Divider>
            <CardContent>
                <Box sx={{
                    display: 'flex',
                    padding: 1
                }}>
                    <Box
                        sx={{
                            padding: 1,
                            width: '60%'
                        }}
                    >
                        <FormControl
                            fullWidth
                            variant="outlined"
                            sx={{
                                marginBottom: 2
                            }}
                        >
                            <TextField
                                size='small'
                                id="outlined-adornment-password"
                                type={showPassword ? 'text' : 'password'}
                                required={true}
                                InputProps={{
                                    endAdornment:
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                edge="end"
                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                }}
                                label="Old Password"
                                value={password.oldPassword}
                                onChange={(e) => handlePasswordChange('oldPassword', e.target.value)}
                            />
                        </FormControl>
                        <FormControl
                            fullWidth
                            variant="outlined"
                            sx={{
                                marginBottom: 2
                            }}
                        >
                            <TextField
                                size='small'
                                id="outlined-adornment-password"
                                type={showPassword ? 'text' : 'password'}
                                required={true}
                                InputProps={{
                                    endAdornment:
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                edge="end"
                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                }}
                                label="New Password"
                                value={password.newPassword}
                                onChange={(e) => handlePasswordChange('newPassword', e.target.value)}
                            />
                        </FormControl>
                        <FormControl
                            fullWidth
                            variant="outlined"
                        >
                            <TextField
                                size='small'
                                id="outlined-adornment-password"
                                type={showPassword ? 'text' : 'password'}
                                required={true}
                                InputProps={{
                                    endAdornment:
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                edge="end"
                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                }}
                                label="Confirm Password"
                                value={password.confirmPassword}
                                onChange={(e) => handlePasswordChange('confirmPassword', e.target.value)}
                            />
                        </FormControl>
                    </Box>
                    <Box sx={{
                        padding: 1
                    }}>
                        <Typography>New Password must contain:</Typography>
                        <ul>
                            <li>At least 8 characters</li>
                            <li>At least 1 lower letter (a-z)</li>
                            <li>At least 1 uppercase letter (A-Z)</li>
                            <li>At least 1 number (0-9)</li>
                            <li>At least 1 special characters</li>
                        </ul>
                    </Box>
                </Box>
            </CardContent>
            <CardActions>
                <Button variant='outlined'>Cancel</Button>
                <Button variant='outlined' disabled={!enableSubmit} onClick={() => handleSubmit()}>Update</Button>
            </CardActions>
        </Card>

    )
}

export default ChangePassword